import * as React from "react";
import { InputBase, styled } from "@mui/material";

//region [[ Styles ]]

const SettingsTextInputView = styled(InputBase)({
  boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.04)",
  borderRadius: "3px",
  background: "white",
  width: "100%",
  "& input, & textarea": {
    color: "#5C5C5D",
    // textAlign: "center",
    fontSize: "11px",
    fontWeight: 600,
    padding: "6px 8px",
  },
  "& input:disabled, & textarea:disabled": {
    color: "#999999",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SettingsTextInputProps {
  onChange: (e) => void;
  value: string;
  autoFocus?: boolean;
  isTextArea?: boolean;
  disabled?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SettingsTextInput = ({ ...props }: SettingsTextInputProps) => {
  const selectAllText = (e) => {
    e.target.select();
  };

  return (
    <SettingsTextInputView
      className={"settings-text-input"}
      onClick={selectAllText}
      onChange={props.onChange}
      value={props.value}
      autoFocus={props.autoFocus}
      multiline={props.isTextArea}
      minRows={props.isTextArea ? 4 : 1}
      disabled={props.disabled}
    />
  );
};
